import React from 'react';

const TYPE_CONFIG = {
  info:      { label: 'INFO',      className: 'intel-badge-info' },
  concern:   { label: 'CONCERN',   className: 'intel-badge-concern' },
  request:   { label: 'REQUEST',   className: 'intel-badge-request' },
  objection: { label: 'OBJECTION', className: 'intel-badge-objection' },
};

export default function CustomerIntel({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <div className="customer-intel">
      <div className="intel-header">Customer Intel</div>
      <div className="intel-list">
        {items.map((item, i) => {
          const cfg = TYPE_CONFIG[item.type] || TYPE_CONFIG.info;
          return (
            <div key={i} className="intel-item">
              <span className={`intel-badge ${cfg.className}`}>{cfg.label}</span>
              <span className="intel-text">
                {typeof item.text === 'string' ? item.text : JSON.stringify(item.text)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
